<div class="dialog">
  <div class="dialog__header clickable">
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <!-- message -->
  <div [formGroup]="formGroup" class="dialog__content" mat-dialog-content>
    <div class="dialog__message" [innerHTML]="data.content"></div>
    <!-- custom input -->
    @if(data.displayEmailInput) {
    <div class="input">
      <app-input-text label="E-mail" formControlName="email" placeholder="Digite o e-mail">
      </app-input-text>
    </div>
    }
  </div>
  <!-- actions -->
  <div class="dialog__actions">
    <button mat-flat-button class="btn-default btn" type="button" (click)="onRightButton()">
      <span>{{ data.saveButtonLabel }}</span>
    </button>
    <button class="dialog__cancel" mat-flat-button mat-dialog-close (click)="onCancel()">
      <span>{{ data.cancelButtonLabel }}</span>
    </button>
  </div>
</div>